<template>
  <div
    class="warning-maintain-message d-flex align-items-center my-3"
  >
    <img
      class="alert-img mr-1"
      alt="alert"
      :src="require('@/assets/images/common/ic-alert.svg')"
    >
    <div>
      <p class="mb-0">
        {{ $t('maintenanceAddFund.des1') }}
      </p>
      <p>
        {{ $t('maintenanceAddFund.des2') }}
      </p>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef,no-restricted-syntax,no-plusplus */

export default {}
</script>
<style lang="scss" scoped>
.warning-maintain-message {
  margin: 10px auto;
  background: rgba(251, 176, 59, 0.1);
  border-radius: 10px;
  padding: 10px 12px 10px 16px;
  max-width: 900px;
}
</style>
